import {
  createRouter,
  createWebHashHistory,
  type RouteRecordRaw,
} from "vue-router";

const routes: RouteRecordRaw[] = [
  { path: "/", name: "home", component: () => import("./views/Home.vue") },
  {
    path: "/news",
    children: [
      {
        path: "",
        name: "news",
        component: () => import("./views/NewsList.vue"),
      },
      {
        path: "details",
        name: "news-detail",
        component: () => import("./views/NewsDetail.vue"),
        props: (route) => ({ sn: route.query.sn }),
      },
    ],
  },
  {
    path: "/:pathMatch(.*)*",
    redirect: { name: "home" },
  },
];

export const mainRouter = createRouter({
  history: createWebHashHistory(),
  routes,
});
